import React, { useContext, useState } from 'react';
import { useNavigate } from "react-router-dom";
import styles from './PermissionCard.module.css';
import { ArrowDownIcon, CopyIcon, LockedIcon, UnlockedIcon } from 'assets/icons';
import useClipboard from 'config/useClipboard';
import ThemeContext from 'config/context/themeContext';
import PermissionActions from './PermissionActions';
import TableContext from 'config/context/tableContext';
import AuthenticationContext from 'config/context/authenticationContext';

const PermissionCard = ({ data, compositions, path, setPath }) => {
    const { dark } = useContext(ThemeContext);
    const navigate = useNavigate();
    const { writeClipboard } = useClipboard();
    const [showComp, setShowComp] = useState(false);
    const { isPermissionValid } = useContext(AuthenticationContext);

    const { setActiveComposition } = useContext(TableContext);

    const viewComposition = (comp) => {
        setActiveComposition(comp);
        navigate("/compositions");
    }

    return (
        <div className={`${styles.component} ${dark ? styles.dark : ""}`}>
            <div className={styles.container}>
                <div className={styles.permission_name}>{data?.name} {isPermissionValid(data?.name) ? <LockedIcon /> : <UnlockedIcon />}</div>
                <div className={styles.permission_details}>
                    <p>parent: <span>{data?.parent}</span></p>
                    <p>public key: <span>{data?.public_key}</span><button onClick={() => writeClipboard(data?.public_key)} className={styles.copy_public_key}><CopyIcon /></button></p>
                    {
                        compositions?.length ? <div className={styles.composition_box}>
                            <div onClick={() => setShowComp(!showComp)} className={`${styles.compositions_top_row} ${showComp ? styles.compositions_top_row__open : ""}`}>
                                <p>compositions:</p> <ArrowDownIcon color={dark ? "#a8a8a8" : ""} />
                            </div>
                            {showComp && <ul className={styles.compositions_list}>
                                {compositions?.map((comp) => {
                                    return (
                                        <li key={comp}>
                                            {comp} <button onClick={() => viewComposition(comp)}>View</button>
                                        </li>
                                    )
                                })}
                            </ul>}
                        </div> : ""
                    }
                </div>
                <PermissionActions name={data?.name} parent={data?.parent} />
            </div>
            <button disabled={data?.children?.length ? false : true} className={styles.open_permission_btn} onClick={() => setPath([...path, data?.name])}><ArrowDownIcon color={"#FFFFFF"} /></button>
        </div>
    )
}

export default PermissionCard;